import { Component, EventEmitter, Input, Output, ViewChild, ElementRef } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { GeneralService } from '../../services/general.service';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-tab-menu-simple',
  imports: [MatButtonModule, MatIconModule, CommonModule],
  templateUrl: './tab-menu-simple.html',
})
export class TabMenuSimple {
  public showLeftButton = false;
  public showRightButton = false;
  @Output() public changeSelected = new EventEmitter<number>();
  @Input() tabs: { descripcion: string; id?: number }[] = [];
  @Input() indexSelected = 0;
  @Input() titule = 'Titulo';
  @Input() paramsName = 'paramTab';

  @ViewChild('tabsContainer', { static: false }) tabsContainer?: ElementRef<HTMLDivElement>;

  constructor(
    private route: ActivatedRoute,
    private generalService: GeneralService,
  ) {
    this.subscribeToParam();
  }

  private subscribeToParam(): void {
    this.route.params.subscribe((params) => {
      if (params[this.paramsName] !== undefined) {
        const value = Number(params[this.paramsName]);
        if (!isNaN(value)) {
          this.indexSelected = value;
        }
      }
    });
  }

  // Emite el índice seleccionado al componente padre
  public onTabChange(index: number): void {
    this.changeSelected.emit(index);
  }

  // Detectar scroll manual para actualizar visibilidad de botones
  public onTabsScroll(): void {
    this.updateScrollButtons();
  }

  ngAfterViewInit(): void {
    this.updateScrollButtons();
    setTimeout(() => this.updateScrollButtons(), 100); // Por si el render es tardado
  }

  private updateScrollButtons(): void {
    const container = this.tabsContainer?.nativeElement;
    if (!container) return;
    this.showLeftButton = container.scrollLeft > 0;
    this.showRightButton = container.scrollWidth > container.clientWidth + container.scrollLeft + 1;
  }

  // Mueve el scroll del contenedor de tabs a la izquierda o derecha
  public scrollTabs(direction: 'left' | 'right'): void {
    const container = this.tabsContainer?.nativeElement;
    if (!container) return;
    const scrollAmount = 100;
    if (direction === 'left') {
      container.scrollLeft -= scrollAmount;
    } else {
      container.scrollLeft += scrollAmount;
    }
    setTimeout(() => this.updateScrollButtons(), 100);
  }
}
